import { render } from "./EvaulationAchievementReport.vue?vue&type=template&id=bca68b94&scoped=true"
import script from "./EvaulationAchievementReport.vue?vue&type=script&lang=js"
export * from "./EvaulationAchievementReport.vue?vue&type=script&lang=js"

import "./EvaulationAchievementReport.vue?vue&type=style&index=0&id=bca68b94&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bca68b94"]])

export default __exports__